import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";

//components
import {
  Curve,
  GiftIcon,
  NewBackButton,
  NoticeIcon,
  TrophyIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../hooks";

import { OfferCard } from "../../../components/loyalty";
import { Desktop } from "../../../containers/common";
import PlayTriviaModal from "./PlayTriviaModal";
import TriviaInfoModal from "./TriviInfoModal";
import { OfferAlertModal } from "../../../components/loyalty";
import TriviaRatingModal from "./triviaRating/TriviaRatingModal";

const formatISODate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() < 12 ? "am" : "pm";
  const formattedDate = `${day}.${month}.${year} | ${hours}:${minutes}${ampm}`;
  return formattedDate;
};

const SelectTrivia = () => {
  const [showModalUnavailable, setModalUnavailable] = useState(false);
  const [unavailableMsg, setModalUnavailableMsg] = useState();
  const [showModalQualified, setModalQualified] = useState(false);
  const [modalQualifiedMessage, setModalQualifiedMessage] = useState("");
  const {
    trivia,
    gameId,
    activeTrivia,
    setActiveTriviaCategory,
    setActiveTrivia,
    activeRewardScheme,
    historyData,
    setActiveRewardScheme,
  } = useTrivia();
  const [playTriviaModal, setPlayTriviaModal] = useState(false);
  const [triviInfoModal, setTriviaInfoModal] = useState(false);
  const [showTriviaRatingModal, setShowTriviaRatingModal] = useState(true);
  const { themeContext, theme } = useTheme();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const selectedCategory = queryParams.get("category");

  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const msg = {
    unplayable:
      "Sorry, this trivia is only available during the festival period.",
    exhaustedAttempts:
      "You have exhausted your number of tries for this trivia and can no longer play.",
  };

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  const handleSingleTriviaOnClick = (triviaCategory) => {
    const mainTrivia = triviaCategory?.trivia[0];
    const {
      maxAttempts,
      canStartPlay,
      isClosed,
      rewardScheme,
      wonRewardMessage,
      wonNoRewardMessage,
      userStats,
    } = mainTrivia;
    const { attempts, hasWon, wonData } = userStats || {};
    if (hasWon) {
      const referenceCode = wonData?.referenceCode;
      const message = referenceCode ? wonRewardMessage : wonNoRewardMessage;
      if (referenceCode) {
        setActiveRewardScheme(rewardScheme);
      }
      setModalQualified(true);
      setModalQualifiedMessage(message);
      setActiveTrivia(mainTrivia);
    } else if (attempts >= maxAttempts) {
      setModalUnavailableMsg(msg.exhaustedAttempts);
      setModalUnavailable(true);
    } else if (!canStartPlay) {
      setModalUnavailableMsg(msg.unplayable);
      setModalUnavailable(true);
    } else {
      setActiveTriviaCategory(triviaCategory);
      setActiveTrivia(mainTrivia);
      setActiveRewardScheme(mainTrivia?.rewardScheme);
      history.push("/trivia/region");
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      const foundCategory = trivia.find(
        (triv) => triv.code === selectedCategory
      );
      if (foundCategory) {
        setActiveTriviaCategory(foundCategory);
        history.push("/trivia/trivia");
      }
    }
  }, [selectedCategory]);

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "fixed",
              zIndex: 10000,
              background: "#fff",
            }}
          >
            <BackButtonContainer
              onClick={() => {
                goToHome();
              }}
              style={{ zIndex: 100 }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <StyledText>Select Trivia</StyledText>
            <NoticeIcon
              fill="black"
              style={{ zIndex: 100 }}
              onClick={() => setTriviaInfoModal(true)}
            />
          </div>
          <DescriptionBody color={mashupBackground}>
            <CurveHolder>
              <Curve fill={mashupBackground} />
            </CurveHolder>
            <ContentHolder>
              {trivia?.map((trivia) => (
                <OfferCard
                  backgroundImage={trivia.imageUrl}
                  description={trivia.description}
                  title={trivia.name}
                  onClick={() => {
                    if (!trivia?.trivia?.length) {
                      const msg =
                        trivia.code === "TUE-T"
                          ? `Available every Tuesday from 12:00 pm to 2:00 pm!`
                          : `${trivia.name} is currently not available`;
                      setModalUnavailableMsg(msg);
                      setModalUnavailable(true);
                    } else if (!trivia.isMultiTrivia) {
                      handleSingleTriviaOnClick(trivia);
                    } else {
                      history.push("/trivia/trivia");
                      setActiveTriviaCategory(trivia);
                    }
                  }}
                />
              ))}
            </ContentHolder>

            {/* <Button style={{ backgroundColor: background, width: "80%" }} onClick={() => history.push('/fastest_finger')}>
              <StyledText color="white">View Orders</StyledText>
            </Button> */}
            <div
              style={{
                width: "80%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "15px",
              }}
            >
              <StyledText>Recent History</StyledText>
              <ViewAllHolder onClick={() => history.push(`/trivia/history`)}>
                <StyledText
                  style={{
                    fontSize: "14px",
                    fontFamily: "MTNRegular",
                    margin: "1px 0 0 0",
                  }}
                  color={background}
                >
                  View all
                </StyledText>
              </ViewAllHolder>
            </div>
            <HistoryContainer>
              {historyData?.map((item) => (
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                    height: 65,
                    borderRadius: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    //   marginTop:15,
                    marginBottom: 15,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: background,
                      width: "15%",
                      height: 65,
                      borderBottomLeftRadius: 15,
                      display: "flex",
                      borderTopLeftRadius: 15,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {item.won ? <TrophyIcon /> : <NoticeIcon />}
                  </div>

                  <div
                    style={{
                      width: "80%",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    <StyledText style={{ fontSize: 12 }}>
                      {`You played ${item.title} ${item.category || ""}${
                        item.won
                          ? item.hasRedeemed
                            ? ", won and redeemed"
                            : " and won"
                          : ""
                      }`}
                    </StyledText>
                    <StyledText
                      style={{
                        fontSize: 10,
                        color: "#7F7F7F",
                        marginTop: -5,
                      }}
                    >{`Played on ${formatISODate(item.createdAt)}`}</StyledText>
                  </div>
                </div>
              ))}
            </HistoryContainer>
          </DescriptionBody>
        </Children>
      </MainHolder>
      {playTriviaModal && (
        <PlayTriviaModal onBackDropClick={() => setPlayTriviaModal(false)} />
      )}
      {triviInfoModal && (
        <TriviaInfoModal onBackButtonClick={() => setTriviaInfoModal(false)} />
      )}
      {showModalUnavailable && (
        <OfferAlertModal
          background={background}
          hideModal={() => {
            setModalUnavailable(false);
            history.push(`/trivia/trivia-category`);
          }}
          title="Trivia not available"
          description={unavailableMsg}
        />
      )}
      {showModalQualified && (
        <OfferAlertModal
          background={background}
          hideModal={() => {
            setModalQualified(false);
            const {
              userStats: {
                wonData: { voucher },
              },
              availableRewardTypes,
            } = activeTrivia;
            if (
              activeRewardScheme === "online" ||
              availableRewardTypes.length
            ) {
              if (voucher && voucher != "airtime") {
                history.push(`/trivia/order_details`);
              } else {
                // Check if reward types are listed
                if (availableRewardTypes?.length) {
                  history.push(`/trivia/pick`);
                }
              }
            } else {
              history.push(`/trivia/redeem-onground`);
            }
          }}
          title={"Congratulations"}
          description={modalQualifiedMessage}
        />
      )}

      {/* {showTriviaRatingModal&& <TriviaRatingModal/>} */}
    </>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  margin-top: 50px;
`;

const ContentHolder = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: "5px";
`;
const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
export default SelectTrivia;
